import React from "react";
import {
  Menu,
  Pane,
  SideSheet,
  Text,
  SearchIcon,
  GraphIcon,
  RemoveRowBottomIcon,
  CreditCardIcon,
  ChartIcon,
  HeadsetIcon,
  ApplicationsIcon,
  PersonIcon,
  LockIcon,
  RefreshIcon,
  PowerIcon,
  DashboardIcon,
} from "evergreen-ui";
import { getCookie } from "../util";
import { withRouter } from "react-router-dom";

const MenuDrawer = (props) => {
  const {
    isShown,
    showMenuDrawer,
    showEscalationMatrixDialog,
    showConfirmationDialog,
    logout,
    showSwitchClubDialog,
    showChangePasswordDialog,
    showAddDeskPersonDialog,
    syncAvailability,
  } = props;

  const userClubs = getCookie("userClubs");

  return (
    <SideSheet
      width={"80%"}
      position={"right"}
      isShown={isShown}
      onCloseComplete={() => showMenuDrawer(false)}
      containerProps={{
        marginLeft: "20%",
      }}
    >
      <Pane
        height={"100%"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
      >
        <Pane>
          <Menu.Group title={<Text size={400}>Menu</Text>}>
            <Menu.Divider />
            <Menu.Item
              paddingTop={10}
              icon={SearchIcon}
              onSelect={() => props.history.push("/search")}
            >
              <Text size={400}>Search</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={GraphIcon}
              onSelect={() => props.history.push("/dashboard")}
            >
              <Text size={400}>Dashboard</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={RemoveRowBottomIcon}
              onSelect={() => props.history.push("/bulk-booking")}
            >
              <Text size={400}>Bulk Booking</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={DashboardIcon}
              onSelect={() => props.history.push("events")}
            >
              <Text size={400}>Events</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={CreditCardIcon}
              onSelect={() => props.history.push("/pricing")}
            >
              <Text size={400}>Pricing</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={ChartIcon}
              onSelect={() => props.history.push("/reports")}
            >
              <Text size={400}>Reports</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={HeadsetIcon}
              onSelect={() => showEscalationMatrixDialog(true)}
            >
              <Text size={400}>Contact Support</Text>
            </Menu.Item>
            {userClubs && userClubs.length > 1 && (
              <Menu.Item
                paddingTop={10}
                icon={ApplicationsIcon}
                onSelect={() => showSwitchClubDialog(true)}
              >
                <Text size={400}>Switch Club</Text>
              </Menu.Item>
            )}
            <Menu.Item
              paddingTop={10}
              icon={PersonIcon}
              onSelect={() => showAddDeskPersonDialog(true)}
            >
              <Text size={400}>Add Desk Person</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={LockIcon}
              onSelect={() => showChangePasswordDialog(true)}
            >
              <Text size={400}>Change Password</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={RefreshIcon}
              onSelect={() => syncAvailability()}
            >
              <Text size={400}>Sync Availability</Text>
            </Menu.Item>
            <Menu.Item
              paddingTop={10}
              icon={PowerIcon}
              onSelect={() =>
                showConfirmationDialog({
                  status: true,
                  confirmLabel: "Logout",
                  information: "Are you sure you want to logout?",
                  action: logout,
                })
              }
            >
              <Text size={400}>Logout</Text>
            </Menu.Item>
          </Menu.Group>
        </Pane>
      </Pane>
    </SideSheet>
  );
};

export default withRouter(MenuDrawer);
